import React from 'react';
import { clsx } from 'clsx';
import styles from './SliderNavigationButton.module.scss';
import { Icon } from '@/src/shared/components/Icon';

type Props = {
  buttonId?: string;
  variant: 'next' | 'prev';
  className?: string;
  disabled?: boolean;
  children?: React.ReactNode;
  onClick?: () => void;
  iconColor?: string;
  iconSize?: number;
  classes?: {
    disabled?: string;
  };
};

export function SliderNavigationButton({
  buttonId,
  variant,
  className,
  children,
  onClick,
  disabled,
  iconColor,
  iconSize,
  classes,
}: Props) {
  return (
    <span
      onClick={disabled ? undefined : onClick}
      className={clsx(styles.sliderNavigationButton, className, buttonId, {
        [styles.next]: variant === 'next',
        [styles.prev]: variant === 'prev',
        [styles.disabled]: disabled,
        ...(classes?.disabled != null && { [classes?.disabled]: disabled }),
      })}
    >
      {children ?? (
        <Icon
          name={variant === 'next' ? 'chevron-right' : 'chevron-left'}
          fontSize={iconSize}
          color={iconColor}
        />
      )}
    </span>
  );
}
